export default __webpack_public_path__ + "static/media/honey_hunter_icon.b59c4dca.svg";